import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { CheckCircle2, Loader2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e2) { setError(formatApiErrorDetail(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6"><div className="bg-teal-500/20 text-teal-500 p-2 rounded-full"><CheckCircle2 size={20} /></div><span className="font-display font-bold">Onboarding Follow-Up</span></div>
        {done ? (
          <div data-testid="forgot-success" className="bg-white p-6 rounded-xl border border-slate-200">
            <h2 className="font-display text-lg font-bold text-slate-900">Revisa tu correo</h2>
            <p className="text-sm text-slate-500 mt-2">Si el correo está registrado, enviaremos un enlace de recuperación válido por 1 hora.</p>
            <Link to="/login" className="inline-flex items-center gap-1 text-blue-600 text-sm mt-4"><ArrowLeft size={14} /> Volver a ingresar</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white p-6 rounded-xl border border-slate-200 space-y-4">
            <h2 className="font-display text-lg font-bold text-slate-900">Recuperar contraseña</h2>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.cl"
              className="w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button data-testid="forgot-submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60">
              {loading && <Loader2 size={16} className="animate-spin" />} Enviar enlace
            </button>
            <Link to="/login" className="inline-flex items-center gap-1 text-slate-500 text-sm"><ArrowLeft size={14} /> Volver</Link>
          </form>
        )}
      </div>
    </div>
  );
}
